  <template>
  <div>
    <van-nav-bar
      title="基金说明"
      left-text="返回"
      left-arrow
      @click-left="$router.push('/member/stable_coinbao')"

    />
   
    <div class="tableDetails">       
        <van-row>
          <p v-html="stablebao_funding_description"></p>
           
          </van-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "StablebaoFundingDescription",
  data() {
    return {
      date: new Date(),
      stablebao_funding_description: '',
      
    };
  },
  computed: {},
  methods: {
  getStablebaoDescription() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "sysconfig",
            token: sessionStorage.getItem("token"),
            name: "stablebao_funding_description",
          },
        })
        .then(function (res) {
          let resData = res.data;
          if (res.data.code === 1) {
            let resData = res.data;
            that.stablebao_funding_description = resData.data;
          } else if (res.data.code === 0 || res.data.code === -1) {
            that.$toast.fail(resData.msg);
          }
        });
    },
    isLogin() {
      let that = this;
      if (!that.$store.state.loginType) {
        that.$router.push("/login");
      }
    },
  },
  mounted() {
    this.getStablebaoDescription();
  },
};
</script>

<style scoped>
.tableDetails {
  margin-top: 10px;
  font-size: 14px;
  padding: 0px 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/StablebaoFundingDescription.vue